// const cookies = require('./cookies');

// let enableCookies = true;

// if (enableCookies && cookies.getCookie('loadPopup') == '') {
    if($('#myModal').length > 0){
        $('#myModal').modal('show');
    }
    // cookies.setCookie('loadPopup', true, 1);
// }